<script lang="ts">
    import { DEFAULT_LAYOUT } from '$lib/components/constants';

    import { getColor } from '$lib/helper';
    import { personalizeHtml } from '$lib/personalizeHtml';

    import TextView from './Text.View.svelte';

    import type { TextContent } from '$lib/types/Components/Text/TextContent';
    import type { Language } from '$lib/types/Language';
    import type { Theme, TransitionEffect } from '$lib/types/Theme';
    import type { TrackingProperty } from '$lib/types/TrackingProperty';

    export let id = '';
    export let content: TextContent;
    export let theme: Theme;
    export let transitionDelay: number;
    export let transitionEffect: TransitionEffect = 'default';
    export let campaignId: string;
    export let trackingProperties: TrackingProperty[];
    export let language: Language = 'en';
    export let layout = DEFAULT_LAYOUT;

    const personalizedHtml = personalizeHtml(content.wysiwygHtml, {
        trackingProperties,
        campaignId,
        language,
    });
</script>

<TextView
    {id}
    wysiwygHtml={personalizedHtml}
    align={content.align}
    color={getColor(content.color, theme.fontColor)}
    box={content.box}
    isHeading={content.isHeading}
    {transitionDelay}
    {transitionEffect}
    {layout}
/>
